export const thirdPartyCheckBoxDialogHandler = {
    methods: {
        showThirdPartyCheckBoxDialog(){
            this.$refs.thirdPartyCheckBoxDialog.showDialog();
        }
    }
}